/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SegmentStatusLog
 */
export interface SegmentStatusLog {
    /**
     * 
     * @type {string}
     * @memberof SegmentStatusLog
     */
    createdBy?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof SegmentStatusLog
     */
    createdAt?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof SegmentStatusLog
     */
    updatedBy?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof SegmentStatusLog
     */
    updatedAt?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof SegmentStatusLog
     */
    id?: string | null;
    /**
     * 
     * @type {SegmentStatusLogStatusEnum}
     * @memberof SegmentStatusLog
     */
    status: SegmentStatusLogStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SegmentStatusLog
     */
    comment?: string | null;
}


/**
 * @export
 */
export const SegmentStatusLogStatusEnum = {
    Open: 'Open',
    InLocalReview: 'InLocalReview',
    InGlobalReview: 'InGlobalReview',
    Approved: 'Approved'
} as const;
export type SegmentStatusLogStatusEnum = typeof SegmentStatusLogStatusEnum[keyof typeof SegmentStatusLogStatusEnum];


/**
 * Check if a given object implements the SegmentStatusLog interface.
 */
export function instanceOfSegmentStatusLog(value: object): value is SegmentStatusLog {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function SegmentStatusLogFromJSON(json: any): SegmentStatusLog {
    return SegmentStatusLogFromJSONTyped(json, false);
}

export function SegmentStatusLogFromJSONTyped(json: any, ignoreDiscriminator: boolean): SegmentStatusLog {
    if (json == null) {
        return json;
    }
    return {
        
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedBy': json['updatedBy'] == null ? undefined : json['updatedBy'],
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'id': json['id'] == null ? undefined : json['id'],
        'status': json['status'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function SegmentStatusLogToJSON(json: any): SegmentStatusLog {
    return SegmentStatusLogToJSONTyped(json, false);
}

export function SegmentStatusLogToJSONTyped(value?: SegmentStatusLog | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'createdBy': value['createdBy'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'updatedBy': value['updatedBy'],
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
        'id': value['id'],
        'status': value['status'],
        'comment': value['comment'],
    };
}

